import { Component, OnInit } from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-not-found-page',
    templateUrl: './not-found-page.component.html',
    standalone: false
})
export class NotFoundPageComponent implements OnInit {

  serviceORresource = environment.serviceORresource;

  constructor() { }

  ngOnInit() {
  }

}
